import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { CloseDialogIcon } from "assets/styles/icons";
import { useProgress } from "context/ProgressProvider";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LoanService } from "services/LoanService";
import {
  AppPrimaryButton,
  AppSecondaryButton,
} from "shared/components/AppComponents";
import { LoanStatusCode } from "shared/helpers/Constants";
import Utils from "shared/helpers/Utils";
import { AuthActions } from "state/auth/Action";
import { ProfileActions } from "state/profile/Action";

const DialogFirstMortgage = ({
  properySecurityRequired,
  setProperySecurityRequired,
}) => {
  const [requestCallback, setShowRequestCallback] = useState(false);
  const [isRequesting, setIsRequesting] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentProfile, isBroker } = useProgress();
  const authInfo = useSelector((state: any) => state.authState);

  const onRequestingCallBack = (): any => {
    setIsRequesting(true);
    LoanService.requestCallBack(currentProfile.loadId)
      .then((response: any) => {
        console.log(response);
        setProperySecurityRequired("");
        setShowRequestCallback(true);
        Utils.handleSuccessResponse(response);
        dispatch(
          ProfileActions.setSblProfile({
            isPropertyOwned: false,
          }),
        );
      })
      .catch((error: any) => {
        Utils.handleErrorResponse(error);
      })
      .finally(() => {
        setIsRequesting(false);
      });
  };

  const actionOnRequestCallBack = (): void => {
    onRequestingCallBack();
  };

  console.log("property", !currentProfile.isPropertyOwned);

  // Hooks
  useEffect(() => {
    if (properySecurityRequired.includes("callback")) {
      setShowRequestCallback(true);
    }
  }, [properySecurityRequired]);

  // UI Elements
  return (
    <>
      <Dialog open={requestCallback} fullWidth maxWidth="sm">
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h2">
              Thank you! We’ll be in touch shortly
            </Typography>
            <IconButton
              onClick={() => {
                setShowRequestCallback(false);
              }}
            >
              <CloseDialogIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography variant="h3" fontWeight={400} mb={3}>
            {isBroker ? (
              <>
                Our lending team will contact you soon to discuss finance
                options that could work for your customer.
                <br />
                <br />
                We’ve saved your customer application so you won’t lose any
                progress.
              </>
            ) : (
              <>
                Our lending team will contact you soon to discuss finance
                options that could work for you.
                <br />
                <br />
                We’ve saved your application so you won’t lose any progress.
              </>
            )}
          </Typography>
        </DialogContent>

        <DialogActions sx={{ gap: "12px" }}>
          <AppSecondaryButton
            title="Cancel"
            className="btn-small ezifin-default-outlined-button"
            onClick={() => setShowRequestCallback(false)}
            fullWidth
          />
          <AppPrimaryButton
            title="Got it"
            className="btn-small"
            onClick={() => {
              setShowRequestCallback(false);
            }}
            fullWidth
          />
        </DialogActions>
      </Dialog>

      <Dialog
        open={
          properySecurityRequired !== "" &&
          !properySecurityRequired.includes("callback")
        }
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h2">Property security required</Typography>
            <IconButton onClick={() => setProperySecurityRequired("")}>
              <CloseDialogIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <>
          <DialogContent>
            <Typography variant="h3" fontWeight={400} mb={3}>
              {properySecurityRequired === "owned"
                ? "For this loan, the property must be owned or connected to one of the applicants."
                : "For this loan application, we require a first mortgage on the property"}
              {/* To proceed with this loan, we require a first mortgage on the property. */}
              <br />
              <br />
              {isBroker
                ? "It looks like this isn’t the case for your customer — but don’t worry, our lending team can still help you explore other finance options that could work for your customer’s situation."
                : "It looks like this isn’t the case for you — but don’t worry, our lending team can still help you explore other finance options that could work for your situation."}
            </Typography>
          </DialogContent>

          <DialogActions sx={{ gap: "12px" }}>
            <AppSecondaryButton
              title="Cancel"
              className="btn-small ezifin-default-outlined-button"
              onClick={() => setProperySecurityRequired("")}
              disabled={isRequesting}
              fullWidth
            />
            <AppPrimaryButton
              title="Request a call back"
              className="btn-small"
              loadingText="REQUESTING"
              isLoading={isRequesting}
              disabled={isRequesting}
              onClick={actionOnRequestCallBack}
              fullWidth
            />
          </DialogActions>
        </>
      </Dialog>
    </>
  );
};

export default DialogFirstMortgage;
